
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sinavlar/[pathListSlug]",
      function () {
        return require("private-next-pages/sinavlar/[pathListSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sinavlar/[pathListSlug]"])
      });
    }
  